<div class="dropdown-menu shadow dropdown-menu-right animated--grow-in show">
  <a class="dropdown-item" href="#" [routerLink]="'my-account/my-infos'" (click)="closeMenu()">
    <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400">
    </i>&nbsp;Mon compte
  </a>
  <div class="dropdown-divider"></div>
  <div class="dropdown-item" (click)="logout()">
    <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400">
    </i>Se déconnecter
  </div>
</div> 
